export default __webpack_public_path__ + "static/uk-f01423cb47475bf7cf12dd4562506635.svg";